import type { IActionButtonsProps } from "../../types";
import { Button } from "@mui/material";

export default function ActionButtons(props: IActionButtonsProps) {
  const { startText, statusText, handleCheckUserStatus } = props;

  return (
    <>
      <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mb: 3 }}>
        {startText}
      </Button>

      <Button fullWidth variant="contained" color="primary" onClick={() => handleCheckUserStatus()}>
        {statusText}
      </Button>
    </>
  );
}
